import filterFunctions from '../adminListSearch/util/filterFunctions';

export const filterItemsFunctionCreator = baseFilters =>
  (items, attribute, operator, value) => {
    if (attribute && operator && value) {
      const funcCreator = filterFunctions[operator].func;
      const filterFunc = funcCreator(value);
      return items.filter(item => {
        const result = filterFunc(item[attribute]);
        // eslint-disable-next-line max-len
        // console.log(`attribute: ${attribute}, value: ${item[attribute]}, result ${result}`);
        return result;
      });
    } else if (value) {
      const standardFilters = baseFilters.map(combination => {
        const funcCreator = filterFunctions[combination.operator].func;
        const filterFunc = funcCreator(value);
        return {
          attribute: combination.attribute,
          func: filterFunc
        };
      });
      return items.filter(item => {
        for (let i = 0; i < standardFilters.length; i++) {
          const filter = standardFilters[i];
          const animalValue = item[filter.attribute];
          if (filter.func(animalValue) === true) return true;
        }
        return false;
      });
    }
    return items;
  };
